import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ArchiveIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 14H9L10 15.5H14L15 14H20M4 14.198V18C4 19.105 4.895 20 6 20H18C19.105 20 20 19.105 20 18V14.198C20 14.066 19.987 13.935 19.961 13.806L18.322 5.608C18.135 4.673 17.314 4 16.36 4H7.64C6.686 4 5.865 4.673 5.678 5.608L4.039 13.806C4.013 13.935 4 14.066 4 14.198Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ArchiveIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ArchiveIcon);
